import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, HostListener, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ResizeableDraggableStatusEnum } from 'src/app/enums/resizeable-draggable-status.enum';

@Component({
  selector: 'app-resizable-draggable',
  templateUrl: './resizable-draggable.component.html',
  styleUrls: ['./resizable-draggable.component.scss']
})
export class ResizableDraggableComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() public width: number;
  @Input() public height: number;
  @Input() public left: number;
  @Input() public top: number;
  @Input() public heightLimit = 0;
  @Input() public widthLimit = 0;
  @Input() public allowMove = true;
  @Input() public allowResize = true;
  @Input() public showControls = true;

  @ViewChild("box") public box: ElementRef;

  @Input() resizeable = true;
  @Input() styleDisabled = false;

  @Output() statusChange = new EventEmitter<ResizeableDraggableStatusEnum>();
  @Output() onMove = new EventEmitter<any>();
  @Output() onResize = new EventEmitter<any>();

  debug = false;

  private statusTimeout: any = null;

  private boxPosition: { left: number, top: number };
  private containerPos: { left: number, top: number, right: number, bottom: number };
  public mouse: { x: number, y: number };
  public status: ResizeableDraggableStatusEnum = ResizeableDraggableStatusEnum.None;
  private mouseClick: { x: number, y: number, left: number, top: number };

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.statusTimeout) {
      clearTimeout(this.statusTimeout);
    }
  }

  ngAfterViewInit() {
    this.loadBox();
    this.loadContainer();
  }

  get style() {
    if (this.styleDisabled) {
      return "";
    }
    return `width:${this.width}px;height:${this.height}px;transform:translate3d(${this.left}px, ${this.top}px, 0px);`;
  }

  private loadBox() {
    const { left, top } = this.box.nativeElement.getBoundingClientRect();
    this.boxPosition = { left, top };
  }

  private loadContainer() {
    const left = this.boxPosition.left - this.left;
    const top = this.boxPosition.top - this.top;
    const right = left + document.body.clientWidth;
    const bottom = top + document.body.clientHeight;
    this.containerPos = { left, top, right, bottom };
    // console.log(this.containerPos);
  }

  setStatus(event: MouseEvent, status: number) {
    if (event.button > 0 || !this.showControls) {
      return;
    }

    if (status === 1) {
      event.stopPropagation();
      this.statusChange.emit(ResizeableDraggableStatusEnum.IsResizing);
    }
    else if (status === 2) {
      if (this.heightLimit > 0 && event.clientY > this.heightLimit + this.top) {
        return;
      }
      if (this.widthLimit > 0 && event.clientX > this.left + this.width - this.widthLimit) {
        return;
      }

      this.mouseClick = { x: event.clientX, y: event.clientY, left: this.left, top: this.top };
      this.statusChange.emit(ResizeableDraggableStatusEnum.IsMoving);
    }
    else {
      this.loadBox();
      this.statusChange.emit(ResizeableDraggableStatusEnum.None);
    }

    this.status = status;
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    this.mouse = { x: event.clientX, y: event.clientY };

    if (this.status === ResizeableDraggableStatusEnum.IsResizing) {
      this.resize();
    }
    else if (this.status === ResizeableDraggableStatusEnum.IsMoving) {
      this.move();
    }
  }

  setSize(width: number, height: number) {
    this.width = width;
    this.height = height;
    this.onResize.emit({ width, height });
  }

  setWidth(value: number) {
    this.width = value;
    this.onResize.emit({ width: this.width, height: this.height });
  }

  setHeight(value: number) {
    this.height = value;
    this.onResize.emit({ width: this.width, height: this.height });
  }

  private resize(): void {
    if (this.canResize()) {
      this.width = Number(this.mouse.x > this.boxPosition.left) ? this.mouse.x - this.boxPosition.left : 0;
      this.height = Number(this.mouse.y > this.boxPosition.top) ? this.mouse.y - this.boxPosition.top : 0;
      this.onResize.emit({ width: this.width, height: this.height });
    }
  }

  private canResize(): boolean {
    if (!this.allowResize || !this.showControls) {
      return false;
    }

    return (this.mouse.x < this.containerPos.right && this.mouse.y < this.containerPos.bottom);
  }

  private move() {
    if (this.canMove()) {
      this.left = this.mouseClick.left + (this.mouse.x - this.mouseClick.x);
      this.top = this.mouseClick.top + (this.mouse.y - this.mouseClick.y);

      this.onMove.emit({ x: this.left, y: this.top });
    }
  }

  private canMove(): boolean {
    if (!this.allowMove || !this.showControls) {
      return false;
    }

    // const offsetLeft = this.mouseClick.x - this.boxPosition.left;
    // const offsetRight = this.width - offsetLeft;
    const offsetTop = this.mouseClick.y - this.boxPosition.top;
    // const offsetBottom = this.height - offsetTop;

    return (
      // this.mouse.x > this.containerPos.left + offsetLeft
      // && this.mouse.x < this.containerPos.right - offsetRight &&
      this.mouse.y > this.containerPos.top + offsetTop
      // && this.mouse.y < this.containerPos.bottom - offsetBottom
    );
  }
}
